import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import {
  CardBody,
  Card,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"
import classnames from "classnames"
import { isMobile } from "react-device-detect"

import LoginLapImag from "../../assets/images/Login PC.png"
import LoginMobImag from "../../assets/images/Login PC.png"
import { ColorRing } from "react-loader-spinner"

import { loginUser, apiError, socialLogin } from "../../store/actions"

const Login = props => {
  const [modalState, setModalState] = useState(false)
  const [activeTab, setActiveTab] = useState("Individual")
  const [activeTabContent, setActiveTabContent] = useState("1")
  const [showPassword, setShowPassword] = useState(false)
  const [alertVisible, setAlertVisible] = useState(true)
  const [messageToken, setMessageToken] = useState("")
  const [helprc, onhelpOpenRC] = useState(false)
  const [toggleMessage, setToggleMessage] = useState("")
  const [profileImgUrl, setProfileImgUrl] = useState("")
  var tawklink = ""
  const [notis, setNoti] = useState(null)
  const [iloader, setILoader] = useState(false)
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState("Login");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);


  const [formData, setFormData] = useState({
    Firstname: '',
    Email: '',
    PhoneNumber: '',
    EmployeeID: '',
    Location: '',
    otp: '',
    Token: messageToken
  });

  useEffect(() => {
  if (props.error && typeof props.error === "string") {
    setIsErrorModalOpen(true);
    setAlertVisible(true); // keep for compat if needed
  }
}, [props.error]);

  useEffect(() => {
  try {
    const storedData = localStorage.getItem('otpFormData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      console.log('Restoring form data on component mount:', parsedData);
      
      setFormData(prevData => ({
        ...prevData,
        Firstname: parsedData.Firstname || prevData.Firstname,
        Email: parsedData.Email || prevData.Email,
        PhoneNumber: parsedData.PhoneNumber || prevData.PhoneNumber,
        EmployeeID: parsedData.EmployeeID || prevData.EmployeeID,
        Location: parsedData.Location || prevData.Location,
        otp: parsedData.otp || prevData.otp,
        Token: parsedData.Token || prevData.Token
      }));
    }
  } catch (error) {
    console.error('Error restoring form data on mount:', error);
  }
}, []);

  useEffect(() => {
    setFormData(prev => ({ ...prev, Token: messageToken }));
  }, [messageToken]);

  useEffect(() => {
    const loader = document.querySelector(".loader")
    setTimeout(() => {
      loader.classList.add("loader--hide")
    }, 100)

    handleNotification()

    setMessageToken(localStorage.getItem("notificationToken"))
  }, [])

  const toggle1 = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  async function handleNotification() {
    Notification.requestPermission()
      .then(result => {
        if (result === "granted") {
          console.log("Notification permission granted.")
          setNoti("Notification permission granted")
        } else {
          setNoti("permission denied")
          console.log("Permission denied for notifications.")
        }
      })
      .catch(error => {
        setNoti("An error occurred while requesting notification permission:")
        console.error(
          "An error occurred while requesting notification permission:",
          error
        )
      })
  }
  useEffect(() => {
    handleNotification()
  }, [])

  const Alldata = JSON.parse(localStorage.getItem("dataJ"))
  const toggleModal = () => setModalState(!modalState)
  const togglePasswordVisibility = () => setShowPassword(!showPassword)
  const hideAlert = () => setAlertVisible(false)
  
  const handleValidSubmit = (event, values) => {
    event.preventDefault(); // Prevent default form submission behavior
    console.log(" login values : ", values);
    console.log(" props.history : ",  props.history);
    props.loginUser(values, props.history)
  }

  const handleValidSubmit1 = (event, values) => {
    event.preventDefault(); // Prevent default form submission behavior

    // Update formData state with current form values
    // setFormData({
    //   Firstname: values.Firstname || formData.Firstname,
    //   Email: values.Email || formData.Email,
    //   otp: values.otp || formData.otp,
    //   Token: values.Token || formData.Token
    // });

    // Add the current action to the form values
    // const updatedValues = {
    //   ...values,
    //   customaction: currentAction
    // };

    props.loginUser(formData, props.history);
  }

//   const clearStoredFormData = () => {
//   try {
//     localStorage.removeItem('otpFormData');
//     console.log('Stored form data cleared from localStorage');
//   } catch (error) {
//     console.error('Error clearing form data from localStorage:', error);
//   }
// }

  // Handle button clicks without form submission
  const handleButtonClick = (action, event) => {
    event.preventDefault();
    event.stopPropagation();

    setCurrentAction(action);

    // Capture current form state
    const currentFormState = { ...formData };

    // Get current form values from DOM as backup
    const form = event.target.closest('form');
    const formElements = form.elements;

    const currentValues = {
      Firstname: formElements.Firstname?.value || currentFormState.Firstname || '',
      Email: formElements.Email?.value || currentFormState.Email || '',
      otp: formElements.otp?.value || currentFormState.otp || '',
      Token: formElements.Token?.value || currentFormState.Token || messageToken || '',
      customaction: action
    };

    console.log(currentValues);

    // Store form data in localStorage when Generate OTP button is clicked
    if (action === 'generate') {
      const formDataToStore = {
        Firstname: currentValues.Firstname,
        Email: currentValues.Email
      };

      try {
        localStorage.setItem('otpFormData', JSON.stringify(formDataToStore));
        console.log('Form data stored in localStorage:', formDataToStore);
      } catch (error) {
        console.error('Error storing form data in localStorage:', error);
      }
    }

    // Call Redux action
    props.loginUser(currentValues, props.history);

    // Restore form data after 1 second
    setTimeout(() => {
      if (action === 'generate') {
        // Restore from localStorage for Generate OTP
        try {
          const storedData = localStorage.getItem('otpFormData');
          if (storedData) {
            const parsedData = JSON.parse(storedData);
            console.log('Restoring form data from localStorage:', parsedData);

            setFormData({
              Firstname: parsedData.Firstname || '',
              Email: parsedData.Email || '',
              PhoneNumber: parsedData.PhoneNumber || '',
              EmployeeID: parsedData.EmployeeID || '',
              Location: parsedData.Location || '',
              otp: parsedData.otp || '',
              Token: parsedData.Token || messageToken || ''
            });
          }
        } catch (error) {
          console.error('Error retrieving form data from localStorage:', error);
          // Fallback to current values if localStorage fails
          setFormData({
            Firstname: currentValues.Firstname,
            Email: currentValues.Email,
            PhoneNumber: currentValues.PhoneNumber,
            EmployeeID: currentValues.EmployeeID,
            Location: currentValues.Location,
            otp: currentValues.otp,
            Token: currentValues.Token
          });
        }
      } else {
        // For other actions (like verify), restore from current values
        setFormData({
          Firstname: currentValues.Firstname,
          Email: currentValues.Email,
          PhoneNumber: currentValues.PhoneNumber,
          EmployeeID: currentValues.EmployeeID,
          Location: currentValues.Location,
          otp: currentValues.otp,
          Token: currentValues.Token
        });

        // clearStoredFormData();
      }
    }, 1000);
  }

  const toggleTermsModal = () => {
    setIsTermsModalOpen(!isTermsModalOpen);
  };

  const handleTabToggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const handleToggleMessage = event => setToggleMessage(event.target.value)

  const handleProfileImageUpload = async file => {
    setILoader(true)
    const uploadedImageUrl = await uploadActivity(file)
    if (uploadedImageUrl) {
      setProfileImgUrl(uploadedImageUrl)
      setILoader(false)
    }
  }

  // const renderAlert = () => {
  //   if (props.error && typeof props.error === "string") {
  //     let alertTitle = ""
  //     let alertType = "warning"

  //     if (
  //       props.error ===
  //       "Your ID has been registered. Please come back again on the event day to log in." ||
  //       props.error ===
  //       "User Already registered , Please come back again on the event day to log in." ||
  //       props.error === "Somethiing went wrong, Please try again!"
  //     ) {
  //       alertTitle = props.error.includes("already registered")
  //         ? "Already Registered"
  //         : "Registered Successfully"
  //       alertType = "success"
  //     }

  //     return (
  //       <SweetAlert
  //         style={{ color: "#000" }}
  //         show={alertVisible}
  //         type={alertType}
  //         title={alertTitle}
  //         onConfirm={hideAlert}
  //       >
  //         {props?.error}
  //       </SweetAlert>
  //     )
  //   }
  //   return null
  // }

  return (
    <React.Fragment>
      <MetaTags>
        <title>FujiFilm Annual Day 2026</title>
      </MetaTags>

      {/* Error Modal */}
        <Modal isOpen={isErrorModalOpen} toggle={() => setIsErrorModalOpen(false)} size="sm" centered>
          {/* Header */}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "14px 18px",
            background: "linear-gradient(135deg, #005b43 0%, #288f70 100%)",
            borderTopRightRadius: "16px",
            borderTopLeftRadius: "16px",
            borderBottom: "1px solid rgba(4,120,87,0.18)",
          }}>
            <h5 style={{ margin: 0, color: "#fff", fontSize: 15, fontWeight: 600, display: "flex", alignItems: "center", gap: 8 }}>
              <i className="bx bx-bell" style={{ color: "#f87171", fontSize: 16 }} />
              Notification
            </h5>
            <button
              type="button"
              onClick={() => setIsErrorModalOpen(false)}
              style={{
                background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 8, color: "#fff", width: 30, height: 30,
                cursor: "pointer", fontSize: 18, lineHeight: 1,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >
              &times;
            </button>
          </div>

          {/* Body */}
          <div style={{ background: "#f7faf9", padding: "20px 18px 16px", borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 14, marginBottom: 20 }}>
              <div style={{
                flexShrink: 0, width: 44, height: 44, borderRadius: "50%",
                background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center"
              }}>
                <i className="bx bx-error-circle" style={{ color: "#dc2626", fontSize: 24 }} />
              </div>
              <div>
                <p style={{ margin: "0 0 4px", fontSize: 15, fontWeight: 600, color: "#1a3a2e" }}>
                  {props.error?.includes("registered") ? "Already Registered" : "Notice"}
                </p>
                <p style={{ margin: 0, fontSize: 14, color: "#4b5563", lineHeight: 1.6 }}>
                  {props.error}
                </p>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={() => setIsErrorModalOpen(false)}
                style={{
                  padding: "8px 28px", borderRadius: 8, cursor: "pointer",
                  fontSize: 14, fontWeight: 600,
                  background: "linear-gradient(135deg, #005b43, #059669)",
                  color: "#fff", border: "none"
                }}
              >
                OK
              </button>
            </div>
          </div>

          {/* Footer accent */}
          <div style={{ height: 3, width: "94%", margin: "0 auto", background: "linear-gradient(90deg, #065f46, #34d399, #065f46)", borderRadius: "0 0 16px 16px" }} />
        </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={isTermsModalOpen} toggle={toggleTermsModal} size="xl" scrollable style={{ width: "auto" }} centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Terms and Conditions</h5>
          <button
            type="button"
            onClick={toggleTermsModal}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <style>
            {`
              @keyframes popupAnimation {
                0% {
                  opacity: 0;
                  transform: translateY(-20px) scale(0.95);
                }
                100% {
                  opacity: 1;
                  transform: translateY(0) scale(1);
                }
              }
              
              .popup-heading {
                animation: popupAnimation 0.6s ease-out forwards;
                animation-delay: 0.2s;
                opacity: 0;
              }
              
              .popup-subheading {
                animation: popupAnimation 0.5s ease-out forwards;
                animation-delay: 0.4s;
                opacity: 0;
              }
              
              .popup-subheading:nth-of-type(even) {
                animation-delay: 0.6s;
              }
              
              .popup-subheading:nth-of-type(3n) {
                animation-delay: 0.8s;
              }
              
              /* Table styling */
              .styled-table table {
                width: 100%;
                background: gray;
                border-collapse: collapse;
              }

              .styled-table th,
              .styled-table td {
                font-size: 15px;
                border: 1px solid #ddd;
                padding: 8px;
                text-align: center;
                color: black;
              }

              .styled-table th {
                background-color: #f2f2f2;
                font-weight: bold;
              }

              .styled-table tr:nth-child(even) {
                background-color: #f9f9f9;
                font-weight: light !important;
              }

              .styled-table tr:nth-child(odd) {
                background-color: #ffffff;
                font-weight: light !important;
              }

              .styled-table tr:hover {
                background-color: #f1f1f1;
              }

              /* Responsive styling */
              @media (max-width: 768px) {
                .styled-table table,
                .styled-table thead,
                .styled-table tbody,
                .styled-table th,
                .styled-table td,
                .styled-table tr {
                  display: block;
                }

                .styled-table tr {
                  margin-bottom: 15px;
                }

                .styled-table td,
                .styled-table th {
                  text-align: left;
                  /* padding-left: 50%; */
                  position: relative;
                }

                .styled-table td:before,
                .styled-table th:before {
                  content: attr(data-label);
                  position: absolute;
                  left: 10px;
                  font-weight: bold;
                  text-align: left;
                }

                .styled-table thead {
                  display: none;
                }
              }
            `}
          </style>
          <div style={{ maxHeight: '70vh', overflowY: 'auto', padding: '10px' }}>
            {/* Summary Section First */}
            <div style={{
              backgroundColor: '#1a1a1a',
              padding: '20px',
              borderRadius: '8px',
              marginBottom: '25px',
              border: '1px solid #333333'
            }}>
              <h4 className="popup-heading" style={{ color: '#0071ce', marginBottom: '15px', fontSize: '1.3rem' }}>
                Privacy Notice
              </h4>
              <p style={{ lineHeight: '1.6', margin: '0', color: '#ffffff' }}>
                This Walmart Privacy Notice applies to personal information collected by WM Global Technology Services India Private Limited ("WMGTS") and its family of companies for and during the Converge event scheduled on August 29, 2025. Personal information is information that identifies you or reasonably can be linked to information that identifies you as detailed in Walmart Privacy Notice. By providing this information on this form, you hereby consent to allow Walmart to collect, use and disclose the information provided in the manner and for the purpose stated above. The information collected will be retained for the purpose of the above event or as may be required by any applicable law. The Walmart Privacy Notice applies on the websites and mobile services (i.e., mobile apps) for the WMGTS and its family of companies where it is posted. If you are providing Personal Information such information will be used for the purpose of Converge event scheduled to be held on August 29, 2025.
              </p>
              <p style={{ lineHeight: '1.6', marginTop: '15px', color: '#ffffff' }}>
                If you want to know more about your privacy rights, please get in touch with{' '}
                <a href="mailto:converge@walmart.com" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                  converge@walmart.com
                </a>{' '}
                and/or refer to the Walmart Privacy Notice.
              </p>
              <p style={{ lineHeight: '1.6', marginTop: '15px', color: '#ffffff', fontWeight: '600' }}>
                Please refer to the complete Walmart Privacy Notice below.
              </p>
            </div>

            {/* Full Privacy Notice */}
            <div style={{
              borderBottom: '2px solid #0071ce',
              paddingBottom: '20px',
              marginBottom: '30px'
            }}>
              <h4 className="popup-heading" style={{ color: '#0071ce', marginBottom: '15px', fontSize: '1.7rem' }}>
                Walmart Privacy Notice
              </h4>

              {/* Full Privacy Notice Content */}
              <div style={{
                backgroundColor: '#1a1a1a',
                padding: '20px',
                border: '1px solid #333333',
                borderRadius: '6px',
                fontSize: '0.9rem',
                lineHeight: '1.5',
                height: 'auto',
                color: '#ffffff'
              }}>
                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.2rem', marginBottom: '10px' }}>Walmart Privacy Notice</h6>
                <p style={{ color: '#ffffff', marginBottom: '15px' }}>
                  This Notice applies to personal information collected by Walmart Inc. and its family of companies for and during the Converge @ Walmart event scheduled on August 29, 2025. Personal information is information that identifies you or reasonably can be linked to information that identifies you. The Notice applies on the websites and mobile services (i.e., mobile apps) for the Walmart Inc. family of companies where it is posted. If you are providing Personal Information such information will be used for the purpose of Converge @ Walmart event scheduled to be held on August 29, 2025.
                </p>

                <h6 className="popup-subheading" style={{ color: '#ffffff', marginTop: '15px', marginBottom: '8px' }}>Our Notice outlines:</h6>
                <ul style={{ paddingLeft: '20px', marginBottom: '15px', color: '#ffffff' }}>
                  <li>How and why we collect your personal information</li>
                  <li>How your personal information is used and protected</li>
                  <li>When and with whom we share your personal information</li>
                  <li>How you can access and update your personal information</li>
                </ul>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.2rem', marginTop: '15px', marginBottom: '8px' }}>Pledge of Accountability</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  Walmart takes steps to ensure your personal information is managed properly to maintain your trust. We have designated associates who are accountable for compliance with this Walmart Privacy Notice. We expect associates and business partners that handle personal information provided by you to take reasonable measures to maintain the confidentiality of your personal information and to do so in accordance with our policies and the law.
                </p>

                <h6 className="popup-subheading" style={{ color: '#ffffff', marginTop: '15px', marginBottom: '8px' }}>What Are the Categories of Personal Information Collected?</h6>
                <p style={{ marginBottom: '10px', color: '#ffffff' }}>
                  We may collect or receive (and may have collected or received during the 12-month period prior to the Last Updated date of this Notice) the categories of personal information listed below. Not all categories will be collected for every individual.
                </p>
                <ul style={{ paddingLeft: '20px', marginBottom: '15px', color: '#ffffff' }}>
                  <li>Personal identifiers, such as name, phone and email address</li>
                  <li>Internet, application, and network activity, such as cookie IDs and browser visits</li>
                  <li>Location information, such as geo-location information such as state and country</li>
                  <li>Audio, visual, and other sensory information, such as audio and video recordings for the event that will be recorded for those participating in person</li>
                  <li>Employment information, such as occupation, job title, licenses, professional memberships, name of the organization, area of work provided via LinkedIn profile</li>
                  <li>Education information, such as degree and schooling information provided via LinkedIn profile (if available)</li>
                </ul>

                <h6 className="popup-subheading" style={{ color: '#ffffff', marginTop: '15px', marginBottom: '8px' }}>What are the Categories of Sources from Which We Collect Your Personal Information?</h6>
                <p style={{ marginBottom: '10px', color: '#ffffff' }}>
                  We may obtain and combine personal information from different sources, as provided below:
                </p>
                <ul style={{ paddingLeft: '20px', marginBottom: '15px', color: '#ffffff' }}>
                  <li>Provided directly by you</li>
                  <li>Collected from a device associated with you</li>
                  <li>Collected from another company within our family of companies</li>
                  <li>Collected from an external third-party source</li>
                </ul>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.2rem', marginTop: '15px', marginBottom: '8px' }}>Information Provided Directly by You</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  Walmart collects personal information directly from you as part of Converge @ Walmart event scheduled to be held on August 29, 2025. We may also collect photographs or audio/visual recordings on Walmart property or during events and activities relating to this Converge @ Walmart event scheduled on August 29, 2025 with Walmart.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.1rem', marginTop: '15px', marginBottom: '8px' }}>Information We Collect from Another Company within Our Family of Companies</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  We may collect your personal information from another organization within our corporate family of companies.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.2rem', marginTop: '15px', marginBottom: '8px' }}>Information Collected from External Third-Party Sources</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  We may receive information about you from third party sources who are involved with assisting us with this Converge @ Walmart event scheduled on August 29, 2025
                </p>

                <h6 className="popup-subheading" style={{ color: '#ffffff', marginTop: '15px', marginBottom: '8px' }}>What Are the Purposes for Collecting Personal Information?</h6>
                <p style={{ marginBottom: '10px', color: '#ffffff' }}>
                  We may use your personal information for various purposes, including:
                </p>
                <ul style={{ paddingLeft: '20px', marginBottom: '15px', color: '#ffffff' }}>
                  <li>Register you as a participant for the upcoming Converge @ Walmart event scheduled on August 29, 2025 to create and maintain your account</li>
                  <li>To inform you of the sessions that are being held as part of this Converge @ Walmart event.</li>
                </ul>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  To the extent we process deidentified information, we will maintain and use the information in deidentified form and will not attempt to reidentify the information unless permitted by applicable law.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.2rem', marginTop: '15px', marginBottom: '8px' }}>Information Sharing</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  All of the categories of personal information that we collect have been shared with other companies, including those within our corporate family, for the aforesaid purpose. We will only share your personal information within our corporate family of companies as permitted by law, except in the following circumstances:
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.2rem', marginTop: '15px', marginBottom: '8px' }}>Service Providers</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  From time to time, we may utilize service providers to administer this event half of Walmart related to Converge @ Walmart scheduled to be held on August 29, 2025. We require our service providers to keep confidential the information that we obtain from you as a participant. We do not allow our service providers to use or share your information for any purpose other than providing services on our behalf, without your affirmative consent.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.2rem', marginTop: '15px', marginBottom: '8px' }}>Sharing for Legal Requirements and Protection of Our Companies and Others</h6>
                <p style={{ marginBottom: '10px', color: '#ffffff' }}>
                  We may share your information in certain other circumstances, which include situations when sharing is required by law, or we believe sharing will help to protect the safety, property, or our rights or the rights of our participants
                </p>
                <p style={{ marginBottom: '10px', color: '#ffffff' }}>Examples include:</p>
                <ul style={{ paddingLeft: '20px', marginBottom: '15px', color: '#ffffff' }}>
                  <li>Protecting the health or safety of participants</li>
                  <li>Addressing crimes committed on or to our properties</li>
                  <li>Identifying and addressing fraud or financial risk</li>
                  <li>Providing information to law enforcement at their written request</li>
                  <li>Responding to a search warrant, subpoena, or other valid legal inquiry</li>
                </ul>

                <h6 className="popup-subheading" style={{ color: '#ffffff', marginTop: '15px', marginBottom: '8px' }}>Disclosing Personal Information for Business Purposes</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  (the personal information that you provide will be used only for the purpose of attendance at the Converge @ Walmart event and for intimating you about the sessions that will be conducted during the Converge @ Walmart event).
                </p>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  During the 12-month period prior to the Last Updated date of this Notice, we may have disclosed your personal information with certain categories of third parties as described in the sections below.
                </p>

                <h6 className="popup-subheading" style={{ color: '#ffffff', marginTop: '15px', marginBottom: '8px' }}>Categories of Personal Information We Disclose to Each Type of Third Party</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  We may disclose your personal information with certain categories of third parties, as described below.
                </p>

                <table className="styled-table">
                  <thead>
                    <tr className="special-row">
                      <th>Category of Personal Information Disclosed</th>
                      <th>Category of Third-Party Recipient</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Audio, visual, and other sensory information</td>
                      <td>Service providers who will be involved in production and recording of this event scheduled on August 29, 2025</td>
                    </tr>
                    <tr>
                      <td>Personal Identifiers</td>
                      <td>Service providers (such as advertising networks, marketplace sellers, analytics providers, etc.); Business partners;</td>
                    </tr>
                    <tr>
                      <td>Geolocation</td>
                      <td>Service providers that receive data to provide services to a Walmart entity (e.g., analytics providers, advertising networks, cloud storage providers, etc.); Business partners;</td>
                    </tr>
                    <tr>
                      <td>Professional and Employment Information</td>
                      <td>Service providers (such as advertising networks, marketplace sellers, analytics providers, etc.);</td>
                    </tr>
                  </tbody>
                </table>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.2rem', marginTop: '15px', marginBottom: '8px' }}>How Long Do We Retain Your Personal Information?</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  We will keep the personal information we collect about you for as long as necessary to carry out the purposes set forth in this Privacy Notice but no longer than as required or permitted under applicable law or internal Walmart policy. We dispose of the information we collect in accordance with Walmart's retention policies and procedures.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.1rem', marginTop: '15px', marginBottom: '8px' }}>How Do We Secure Your Personal Information?</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  We use reasonable information security measures, including physical, administrative, and technical safeguards. Learn more about measures you can take to help to
                  <a href="https://corporate.walmart.com/privacy-security/stay-secure-online-cybersecurity-hygiene" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                    &nbsp; protect the security of your personal information.
                  </a>
                </p>
                <p style={{ marginBottom: '15px', color: '#ffffff', fontSize: '1.2rem', }}>
                  Participants should be 18 years and above on the date they submit this information and should be a resident of India
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.1rem', marginTop: '15px', marginBottom: '8px' }}>Monitoring and Protection</h6>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1rem', marginTop: '15px', marginBottom: '8px' }}>Cameras</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  To ensure the safety and security of our participants and assets, closed circuit television and cameras are used throughout Walmart facilities where the Converge @ Walmart will be held. These cameras are used for purposes such as safety and security, asset protection, operations improvement, and deterrence and investigation of misconduct. Cameras will only be used in areas where an individual has an expectation that the individual could be recorded.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1rem', marginTop: '15px', marginBottom: '8px' }}>Equipment and Systems</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  We have a reasonable interest in ensuring that company equipment and systems, as well as data, are protected and used properly. Accordingly, to the extent allowed by applicable law, we monitor or record any and all use of company equipment and systems, including use for personal purposes.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.5rem', marginTop: '15px', marginBottom: '8px' }}>What Are Your California Privacy Rights?</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  If you are a California resident, you can make certain requests regarding your personal information, and we will fulfil each request to the extent required by law. If we are unable to comply with your request in whole or in part, we will notify you with reasons for the denial. We do not offer the option for you to request we stop selling your personal information or sharing it for cross-context behavioral advertising because we do not conduct such selling or sharing of our participant's personal information.
                </p>
                <p style={{ marginBottom: '10px', color: '#ffffff' }}>As stated in more detail below, you can request that we:</p>
                <ul style={{ paddingLeft: '20px', marginBottom: '15px', color: '#ffffff' }}>
                  <li>Provide you with access to a copy of and certain details regarding the personal information we have about you.</li>
                  <li>Delete your personal information.</li>
                  <li>Correct your inaccurate personal information.</li>
                  <li>Limit the use or disclosure of your sensitive personal information (SPI).</li>
                </ul>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  To exercise any of these privacy rights, click "
                  <a href="https://cpa-ui.walmart.com/affirmation?brandCode=WMT&requestType=ACCESS&persona=APPLICANT" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                    Your Privacy Choices
                  </a>
                  ", or call 1-800-Walmart (1-800-925-6278), press one, and say, "Privacy".
                </p>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  <strong style={{ color: '#0071ce', fontSize: '1rem', }}>1. Request to Access My Personal Information:</strong> You have the right to request access to the personal information we may have collected about you.
                </p>
                <p style={{ marginBottom: '10px', color: '#ffffff' }}>
                  Requests to access your personal information may be submitted up to two times in a rolling twelve-month period. In response, we will return to you the following categories of information, to the extent required by law:
                </p>
                <ul style={{ paddingLeft: '20px', marginBottom: '15px', color: '#ffffff' }}>
                  <li>The categories of personal information we have collected about you.</li>
                  <li>The categories of sources from which we collect your personal information.</li>
                  <li>The business or commercial purpose for collecting, selling, or sharing your personal information.</li>
                  <li>The categories of third parties to whom we disclose personal information.</li>
                  <li>The specific pieces of personal information we have collected about you.</li>
                  <li>A list of categories of personal information that we have sold or shared for cross-context behavioral advertising, along with the categories of third parties we sold it to or shared it with for cross-context behavioral advertising.</li>
                  <li>A list of categories of personal information that we have disclosed for a business purpose, along with the categories of third parties we disclosed it to.</li>
                </ul>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  <strong style={{ color: '#0071ce', fontSize: '1rem', }}>2. Delete My Personal Information:</strong> You have the right to ask that we delete your personal information. Once we receive a request, we will delete the personal information (to the extent required by law) we hold about you as of the date of your request from our records and direct our service providers to do the same. Choosing to delete your personal information may impact your ability to use our websites and online features, including closure of your online account, and limit your use of in-store functions that require your personal information.
                </p>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  <strong style={{ color: '#0071ce', fontSize: '1rem', }}>3. Correct My Personal Information:</strong> You have the right to ask that we correct the personal information we may have collected about you if that information is inaccurate. We reserve the right to request identifying documentation from you in certain circumstances, as permitted by law.
                </p>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  <strong style={{ color: '#0071ce', fontSize: '1rem', }}>4. Limit the Use and Disclosure of SPI:</strong> You have the right to ask that we limit our use and disclosure of your SPI to certain purposes permitted by law.
                </p>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  We will not discriminate against you for exercising your rights. We will not deny you goods or services, charge different prices or rates, provide a different level of service or quality of goods, or suggest that you might receive a different price or level of quality for goods. Some programs or membership services require usage of personal information to function, so compliance with your request may impact those experiences.
                </p>

                <h6 className="popup-subheading" style={{ color: '#ffffff', marginTop: '15px', marginBottom: '8px' }}>How Do We Verify Your Identity to Complete Your Access, Correction and Deletion Requests:</h6>
                <p style={{ marginBottom: '10px', color: '#ffffff' }}>
                  If you request access to, or the correction or deletion of, your personal information we will verify your identity before disclosing the requested information. To do so, we may ask that you log into your account or provide us with your:
                </p>
                <ul style={{ paddingLeft: '20px', marginBottom: '15px', color: '#ffffff' }}>
                  <li>First name*, Middle initial, Last name*</li>
                  <li>Address*</li>
                  <li>Email address*</li>
                  <li>Phone number</li>
                </ul>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>*Required field</p>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  When you make a request, you will be asked to answer a few questions about yourself to help us verify your identity. Third-party identification services may help us with verification to prevent disclosure of your personal information resulting from fraudulent requests. You may be asked to log into your online account and complete a one-time passcode validation. In the event more documentation is necessary to verify your identity, we will notify you directly.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.1rem', marginTop: '15px', marginBottom: '8px' }}>What If You Can't Verify My Identity?</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  If we can't verify your identity, we will notify you, and your request(s) to access, request, or delete your personal information may not be processed. Any requests may be denied if we have reason to believe they are fraudulent.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.1rem', marginTop: '15px', marginBottom: '8px' }}>How Do I Submit a Request Using an Authorized Agent?</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  If you'd like an authorized agent to exercise your rights for you, they may use the same links described above to submit requests. We require documentation demonstrating your agent's authority to submit requests on your behalf. For example, a valid power of attorney or other documentation, including a letter, signed by you (the California resident) authorizing the agent to submit your requests. You can download a sample letter from the request form. Documentation may be uploaded at the time you submit your request on our website or provided to us up to 10 business days after. If you submit your request by calling, you can email your forms to
                  <a href="mailto:consumerprivacy@wal-mart.com" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                    &nbsp; consumerprivacy@wal-mart.com.
                  </a>
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.1rem', marginTop: '15px', marginBottom: '8px' }}>Number of Requests Fulfilled Last Calendar Year</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  To view metrics about how many requests we received last year, please click
                  <a href="https://corporate.walmart.com/privacy-security/california-privacy-rights/metrics" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                    &nbsp; How Many California Consumer Privacy Act Requests Did We Fulfill Last Year?
                  </a>
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.1rem', marginTop: '15px', marginBottom: '8px' }}>Shine the Light</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  California residents also have the right to request that we provide you with (a) a list of certain categories of personal information we have disclosed to third parties for their direct marketing purposes during the immediately preceding calendar year and (b) the identity of those third parties. To exercise this right, contact us at the address below.
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.1rem', marginTop: '15px', marginBottom: '8px' }}>Notice of Financial Incentive</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  If we provide a financial incentive, we will provide you with the details, including how the incentive is related to your data before you participate so that you may make an informed decision about whether and how to participate. In the event you decide to take advantage of a financial incentive, you will always have the right to withdraw from participation and we will provide you with directions on how to do so.
                </p>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  Contact our
                  <a href="https://www.walmart.com/help/store-feedback" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                    &nbsp; Customer Service Team
                  </a>
                  or write the Walmart Privacy Office with any questions or comments about this Notice or about how we handle your personal information. The Privacy Office's address is:
                </p>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  Walmart Corporate<br />
                  Privacy Office, MS #0160<br />
                  702 SW 8th Street<br />
                  Bentonville, AR 72716-0160
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.5rem', marginTop: '15px', marginBottom: '8px' }}>UK / EU provisions</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  If you are a resident of UK / EU, you have the following rights where UK / EU data protection laws apply (subject to certain conditions and limitations):
                </p>
                <ul style={{ paddingLeft: '20px', marginBottom: '15px', color: '#ffffff' }}>
                  <li><strong>Access:</strong> The right to be provided with a copy of your personal information.</li>
                  <li><strong>Rectification:</strong> The right to require us to correct any mistakes in your personal information.</li>
                  <li><strong>Erasure (also known as the right to be forgotten):</strong> The right to require us to delete your personal information in certain situations.</li>
                  <li><strong>Restrict Processing:</strong> The right to require us to restrict processing of your personal information in certain circumstances, e.g. if you contest the accuracy of the data.</li>
                  <li><strong>Data portability:</strong> The right to receive the personal information you provided to us, in a structured, commonly used and machine-readable format and/or transmit that data to a third party—in certain situations.</li>
                  <li><strong>Object:</strong><br />
                    (i) at any time to your personal information being processed for direct marketing (including profiling); and<br />
                    (ii) in certain other situations to our continued processing of your personal information, e.g. processing carried out for the purpose of our legitimate interests unless there are compelling legitimate grounds for the processing to continue or the processing is required for the establishment, exercise or defense of legal claims
                  </li>
                  <li><strong>Not Be Subject to Automated Individual Decision Making:</strong> The right not to be subject to a decision based solely on automated processing (including profiling) that produces legal effects concerning you or similarly significantly affects you.</li>
                  <li><strong>Withdraw Consent:</strong> If you have provided us with a consent to use your personal information you have a right to withdraw that consent easily at any time. Withdrawing consent will not affect the lawfulness of our use of your personal information in reliance on that consent before it was withdrawn.</li>
                </ul>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  Depending on whether UK and/or EU data protection laws apply you may have the right to make a complaint to the Information Commissioner's Office (ICO), the UK regulator for data protection issues, and/or to the data protection supervisory authority in your jurisdiction. We would, however, always appreciate the chance to deal with your concerns before you approach a supervisory authority. Contact details for the ICO are available
                  <a href="https://ico.org.uk/global/contact-us/" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                    &nbsp; here
                  </a>
                  . For a list of EEA data protection supervisory authorities and their contact details see
                  <a href="https://www.edpb.europa.eu/about-edpb/about-edpb/members_en" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                    &nbsp; here
                  </a>
                  .
                </p>

                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  UK and EEA data subjects can submit their request to exercise their data privacy rights by emailing
                  <a href="mailto:globalprivacy@wal-mart.com" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                    &nbsp; globalprivacy@wal-mart.com
                  </a>
                </p>

                <h6 className="popup-subheading" style={{ color: '#0071ce', fontSize: '1.1rem', marginTop: '15px', marginBottom: '8px' }}>Contacts for Questions and Concerns Regarding This Notice</h6>
                <p style={{ marginBottom: '15px', color: '#ffffff' }}>
                  You may discuss questions or concerns about this Notice with us at
                  <a href="mailto:converge@walmart.com" style={{ color: 'rgb(255, 123, 241)', textDecoration: 'underline' }}>
                    &nbsp; converge@walmart.com
                  </a>
                </p>

                <p style={{
                  marginTop: '20px',
                  paddingTop: '15px',
                  borderTop: '1px solid #333333',
                  fontStyle: 'italic',
                  color: '#cccccc'
                }}>
                  This Notice does not create an express or implied contract of employment or any other contractual commitment. Walmart may modify this Notice at its sole discretion without notice, at any time, consistent with applicable law.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        size="xl"
        isOpen={modalState}
        toggle={toggleModal}
        centered
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Photo Mosaic</h5>
          <button
            type="button"
            onClick={toggleModal}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            allow="camera; microphone"
            title="test"
            className="embed-responsive-item mosaic"
            src={encodeURI("https://demo-mosaic.herokuapp.com/")}
          />
        </div>
      </Modal>

      <Modal
        isOpen={helprc}
        toggle={() => {
          onhelpOpenRC(!helprc)
        }}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Help Desk</h5>
          <button
            type="button"
            onClick={() => {
              onhelpOpenRC(!helprc)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {Alldata.data.lobby.data.areas.map((item, i) =>
            (() => {
              switch (item.id) {
                case "help": {
                  ; <div>
                    {item.url ? (tawklink = item.url) : (tawklink = "")}
                  </div>
                }
              }
            })()
          )}
          <iframe
            height="450px"
            width="100%"
            title="test"
            className="embed-responsive-item"
            src={encodeURI(tawklink)}
          />
        </div>
      </Modal>

      <Container fluid style={{ padding: 0, position: "relative", height: "100vh", width: "100%" }}>
        <img
          loading="lazy"
          src={
            isMobile
              ? // LoginMobImag
              "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/FujiFilm%20Annual%20Day%202026%2FLogin%20Phone.png?alt=media&token=4082789d-a457-4020-965b-c85c3f47e53b"
              : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/FujiFilm%20Annual%20Day%202026%2FLogin%20Laptop.png?alt=media&token=b1b4edc5-2bf7-46f5-9c13-e1716bb13b7f"
            // LoginLapImag
          }
          style={{ position: "absolute", width: "100%", height: "100%" }}
          alt=" "
        />

        <div className="account-pages pt-sm-5">
          <center className="loginCenter">
            {/* <img src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/salaried%20pl%202025%2Flogo.png?alt=media&token=417a6366-5010-4403-a808-d15d79aad755" style={{ width: "10rem", height: "10rem", position: "absolute", top: "13%", left: "50%", transform: "translateX(-50%)" }}></img> */}
            <Card
              className="overflow-hidden cardLogin"
              style={{ boxShadow: "none", background: "rgba(11, 83, 81, 0)" }}
            >


              <CardBody className="pt-0" style={{ padding: 0 }}>
                <div className="p-2" style={{ color: "#242688" }}>
                  <Nav
                    style={{ columnGap: "2%" }}
                    pills
                    className="navtab-bg nav-justified"
                  >
                    <NavItem>
                      {/* <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "Individual",
                        })}
                        onClick={() => {
                          toggle1("Individual")
                          setActiveTabContent("1")
                        }}
                      >
                        Login
                      </NavLink> */}
                      <div id="1"></div>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "Team",
                        })}
                        onClick={() => {
                          toggle1("Team")
                          setActiveTabContent("2")
                        }}
                      >
                        Register
                      </NavLink>
                    </NavItem> */}
                  </Nav>
                  {/* {renderAlert()} */}
                  <TabContent
                    activeTab={activeTabContent}
                    className="p-3 text-muted"
                  >
                    <TabPane tabId="1">
                      <div id="notifier" style={{ display: "hidden" }}>
                      </div>
                      {/* <h2 style={{ color: "#" }}>Enter your Details</h2> */}
                      <br />
                      <AvForm
                        className="form-horizontal"
                      onValidSubmit={handleValidSubmit}
                      >
                        <div className="mb-1">
                          <p className="login-label">Full Name</p>
                          <AvField
                            name="Firstname"
                            value={formData.Firstname}
                            onChange={(e) => setFormData({ ...formData, Firstname: e.target.value })}
                            className="form-control newgrad"
                            // placeholder="Full Name *"
                            type="text"
                            required
                          />
                        </div>

                        <div className="mb-1">
                          <p className="login-label">Contact</p>
                          <AvField
                            name="PhoneNumber"
                            value={formData.PhoneNumber}
                            onChange={(e) => setFormData({ ...formData, PhoneNumber: e.target.value })}
                            className="form-control newgrad"
                            // placeholder="Contact *"
                            type="text"
                            required
                          />
                        </div>

                        <div className="mb-1">
                          <p className="login-label">Official Email ID</p>
                          <AvField
                            name="Email"
                            value={formData.Email}
                            onChange={(e) => setFormData({ ...formData, Email: e.target.value })}
                            className="form-control newgrad"
                            // placeholder="Official Email ID*"
                            type="email"
                            required
                          />
                        </div>
 
                         <div className="mb-1">
                          <p className="login-label">Employee ID</p>
                          <AvField
                            name="EmployeeID"
                            value={formData.EmployeeID}
                            onChange={(e) => setFormData({ ...formData, EmployeeID: e.target.value })}
                            className="form-control newgrad"
                            // placeholder="Employee ID *"
                            type="text"
                            required
                          />
                        </div>

                        <div className="mb-1">
                          <p className="login-label">Work Location</p>
                          <AvField
                            name="Location"
                            value={formData.Location}
                            onChange={(e) => setFormData({ ...formData, Location: e.target.value })}
                            className="form-control newgrad"
                            // placeholder="Work Location *"
                            type="text"
                            required
                          />
                        </div>

                        {/* <div className="mb-3" style={{ position: "relative" }}>
                          <div id="phoneCont" style={{ display: "flex", justifyContent: "center", gap: "4px", width: "100%" }}>
                            <AvField
                              name="CountryCode"
                              disabled
                              value={formData.CountryCode ? formData.CountryCode : "91"}
                              onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9]/g, '');
                                console.log('Country Code:', value);
                                setFormData({ ...formData, CountryCode: value });
                              }}
                              className="form-control"
                              placeholder="91"
                              type="text"
                              required
                              style={{
                                width: "80px",
                                flex: "0 0 80px"
                              }}
                            />
                            <AvField
                              name="PhoneNumber"
                              value={formData.PhoneNumber}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                console.log('Phone Number:', value, 'Length:', value.length);
                                setFormData({ ...formData, PhoneNumber: value });
                              }}
                              className="form-control"
                              id="phoneHolder"
                              placeholder="Phone Number"
                              type="text"
                              style={{
                                // flex: "1",
                                width: "100%",
                                // backgroundColor: "#ffffff",
                                // color: "#000000",
                                // padding: "7px 16px",
                                // fontSize: "14px",
                                // transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                              }}
                              validate={{
                                required: { value: true, errorMessage: 'Mobile number is required' },
                                pattern: { value: /^[0-9]{10}$/, errorMessage: 'Please enter a valid 10-digit mobile number' }
                              }}
                            />
                          </div>
                        </div> */}

                        {/* <div className="mb-1">
                          <AvField
                            name="otp"
                            value={formData.otp}
                            onChange={(e) => setFormData({ ...formData, otp: e.target.value })}
                            className="form-control"
                            placeholder="OTP *"
                            type="text"
                          // required
                          />
                        </div> */}

                        {/* <div className="mb-1" style={{ display: "flex" }}>
                          <input
                            className="form-control"
                            type="file"
                            accept="image/png,image/jpeg,image/jpg"
                            onChange={e =>
                              handleProfileImageUpload(e.target.files[0])
                            }
                          />
                          <AvField
                            name="ProfileImg"
                            className="form-control"
                            placeholder="Profile photo *"
                            type="hidden"
                            value={profileImgUrl}
                          />
                          {iloader && (
                            <div
                              // style={{
                              //   // position: "absolute",
                              //   top: "71%",
                              //   left: "94%",
                              // }}
                            >
                              <ColorRing
                                visible={true}
                                height="40"
                                width="40"
                                ariaLabel="color-ring-loading"
                                wrapperStyle={{}}
                                wrapperClass="color-ring-wrapper"
                                colors={[
                                  "#e15b64",
                                  "#f47e60",
                                  "#f8b26a",
                                  "#abbd81",
                                  "#849b87",
                                ]}
                              />
                            </div> 
                          )}
                        </div> */}

                        <div className="mb-3">
                          <AvField
                            name="Token"
                            value={formData.Token}
                            onChange={(e) => setFormData({ ...formData, Token: e.target.value })}
                            className="form-control newgrad"
                            placeholder="token"
                            type="text"
                            hidden
                          // required
                          />
                        </div>

                        <div className="mb-3 applebtn">
                          <AvField
                            name="customaction"
                            value="Login"
                            className="form-control newgrad"
                            placeholder="action *"
                            type="text"
                            required
                            disabled
                            hidden
                          />
                        </div>

                        {/* Terms and Conditions Checkbox */}
                        {/* <div className="mb-3 d-flex checkbox-container">
                          <AvField
                            name="acceptTerms"
                            type="checkbox"
                            required
                            style={{ backgroundColor: "#011E60", width: '1.5em', height: '1.5em' }}
                            validate={{
                              required: { value: true, errorMessage: 'You must accept the terms and conditions' }
                            }}
                            customInput
                          >
                          </AvField>
                          <div className="form-checkbox-outline">
                            <label className="form-check-label" htmlFor="acceptTerms" style={{ color: "#000", marginInline: '5% 0', width: '100%' }}>
                              I agree to the{' '}
                              <button
                                type="button"
                                className="btn btn-link p-0"
                                style={{ fontSize: 'inherit', verticalAlign: 'baseline', textDecoration: 'none !important', color: '#011E60' }}
                                onClick={toggleTermsModal}
                              >
                                Terms and Conditions
                              </button>
                              {' *'}
                            </label>
                          </div>
                        </div> */}

                        <div
                          className="mt-3 d-flex justify-content-evenly"
                          style={{ textAlign: "center" }}
                        >
                          {/* <button
                            disabled={iloader ? true : false}
                            style={{
                              background: "#fff",
                              color: "#000000",
                              borderRadius: "8px",
                              outline: "none",
                              border: "1px solid #fff",
                            }}
                            className="btn btn-block"
                            type="button"
                            onClick={(e) => handleButtonClick("generate", e)}
                          >
                            Generate OTP
                          </button> */}

                          <button
                            style={{
                              backgroundColor: "#005b43",
                              color: "white",
                              borderColor: "white",
                              fontWeight: "900",
                              fontSize: "1.25rem",
                              marginRight: "5%",
                              borderRadius: "15px",
                              padding: "0.35rem 3.5rem",
                              border: "none",

                            }}
                            className="btn btn-primary btn-block"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </AvForm>
                      {/* <p className="mt-3 text-white">
                        Please login using your official email ID
                      </p> */}
                    </TabPane>
                    <TabPane tabId="2">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={handleValidSubmit}
                      >
                        <div className="mb-1">
                          <AvField
                            name="Firstname"
                            className="form-control"
                            placeholder="Full Name *"
                            type="text"
                            required
                          />
                        </div>
                        <div className="mb-1">
                          <AvField
                            name="EmployerName"
                            className="form-control"
                            placeholder="Employer Name *"
                            type="text"
                            required
                          />
                        </div>
                        <div className="mb-1">
                          <AvField
                            name="Email"
                            className="form-control"
                            placeholder="Email ID *"
                            type="email"
                            required
                          />
                        </div>
                        <div className="mb-1">
                          <AvField
                            name="storeName"
                            className="form-control"
                            placeholder="Store Name *"
                            type="text"
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <AvField
                            name="customaction"
                            value="Register"
                            className="form-control newgrad"
                            placeholder="action *"
                            type="text"
                            required
                            disabled
                            hidden
                          />
                        </div>
                        <div
                          className="mt-3 d-flex justify-content-evenly"
                          style={{ textAlign: "center" }}
                        >
                          <button
                            style={{
                              backgroundColor: "rgb(255,255,254)",
                              color: "white",
                              borderColor: "white",
                              fontWeight: "bold",
                              marginRight: "5%",
                            }}
                            className="btn btn-primary btn-block"
                            type="submit"
                          >
                            Register
                          </button>
                        </div>
                      </AvForm>
                    </TabPane>
                  </TabContent>
                  {/* {toggleMessage === "Employee"
                    ? "Please enter your name and employee ID."
                    : "Please enter your registered email ID to enter"} */}
                </div>
              </CardBody>
            </Card>
          </center>
        </div>
      </Container>
      {/* help desk btn */}
      <div
        style={{
          display: "none",
          cursor: "pointer",
          height: "80px",
          width: "80px",
          position: "absolute",
          top: "85%",
          right: "10%",
        }}
      >
        <img
          width="100px"
          src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FHELP%20Button.png?alt=media"
          onClick={() => {
            onhelpOpenRC(!helprc)
          }}
        />
        <div style={{ color: "#fff", fontSize: "1.8rem", textAlign: "center", padding: "2% 5%" }}
          className="applebtn"
        ><span>Help</span><span>?</span></div>
      </div>
    </React.Fragment>
  )
}

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
)
